<template>
  <v-container fluid>

    <v-toolbar color="red" dark>
      <v-toolbar-title>Failed Entities</v-toolbar-title>
    </v-toolbar>
    <v-alert
      :value="true"
      type="info"
      outline
      v-if="steps.failed.length ===0 && !loading"
    >
      No failed entities found for this import.
    </v-alert>
    <v-list three-line
            v-if="steps.failed.length > 0">
      <template v-for="(item, index) in steps.failed">
        <v-list-tile
          :key="item.id"
          avatar
          ripple
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ item.entity.Entity_Name }} {{ item.entity.Uuid }}</v-list-tile-title>
            <v-list-tile-sub-title>
             <strong>Reason:</strong> {{ item.description }}
            </v-list-tile-sub-title>
          </v-list-tile-content>

        </v-list-tile>
        <v-divider
          v-if="index + 1 < steps.failed.length"
          :key="index"
        ></v-divider>
      </template>
    </v-list>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import _ from 'underscore'
  import Config from '../utils/Config'
  import AmplifyStore from '../store/store'

  export default {
    data () {
      return {
        selected: null,
        info: null,
        loading: true,
        steps: [],
        errored: false,
        searchTimeout: null,
      }
    },
    mounted () {
      const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken
      axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`
      this.$emit('TriggerLoading', true)
      axios
      .get(`${Config.API_URL}/imports/${this.$route.params.id}`)
       .then(response => {
        this.steps = response.data
        this.loading = false
        this.$emit('TriggerLoading', false)
      })
       .catch(error => {
        this.loading = false
        console.log(error)
        this.errored = true
      })
    },
  }
</script>
